//data-vis
import { VerticalBarSeriesPoint, LineSeriesPoint } from "react-vis";

import { Option } from "../../models/select";
import { Frame } from "../../models/frame";

import moment from "moment";

export const getRelativePosition = (
  el1: HTMLElement,
  el2: HTMLElement,
  targetPosition: "bar" | "line" | "heatmap"
): { x: number; y: number } => {
  const dimension1: DOMRect = el1.getBoundingClientRect() as DOMRect;
  const dimension2: DOMRect = el2 && (el2.getBoundingClientRect() as DOMRect);
  console.log(dimension1, dimension2);
  if (targetPosition === "bar")
    return {
      x: dimension1.x - dimension2.x + dimension1.width + 4, //4 is the padding
      y: Math.min(dimension1.y - dimension2.y - 1, 325) //325px max means box wont drop below x axis
    };
  else if (targetPosition === "line") {
    return {
      x: dimension1.x - dimension2.x - (100 - dimension1.width) / 2, //100 is the box with
      y: Math.min(dimension1.y - dimension2.y - 55 - 2, 325) //55 is box height and 2 is padding
    };
  } else {
    return {
      x: dimension1.left, // - (100 - dimension1.width) / 2,
      y: dimension1.top //- 55 //55 is box height and 2 is padding
    };
  }
};

export const MockData: VerticalBarSeriesPoint[] = [
  { x: "Polaroid", y: 393 },
  { x: "Ray-Ban", y: 2345 },
  { x: "Furla", y: 896 },
  { x: "Lozza", y: 1003 },
  { x: "Carrera", y: 107 },
  { x: "Marc Jacobs", y: 2453 },
  { x: "Sunderson", y: 5673 },
  { x: "Calvin Klein", y: 10003 },
  { x: "Diesel", y: 7003 },
  { x: "Guess", y: 2003 },
  { x: "Coach", y: 103 },
  { x: "Michael Kors", y: 453 }
];

export const MockDataStores: VerticalBarSeriesPoint[] = [
  { x: "Store 1", y: 123 },
  { x: "Store 2", y: 2567 },
  { x: "Store 3", y: 8962 },
  { x: "Store 4", y: 1003 },
  { x: "Store 5", y: 1045 },
  { x: "Store 6", y: 245 },
  { x: "Store 7", y: 673 },
  { x: "Store 8", y: 1003 }
];

export const MockDataPrices: VerticalBarSeriesPoint[] = [
  { x: "$0-100", y: 123 },
  { x: "$100-200", y: 2567 },
  { x: "$200-300", y: 8962 },
  { x: "$300-400", y: 1003 },
  { x: "$400-500", y: 1045 },
  { x: "$500-600", y: 245 }
];

export const MockDataColor: VerticalBarSeriesPoint[] = [
  {
    x: "Brown",
    y: 105,
    color: "#3e2723"
  },
  {
    x: "Black",
    y: 5567,
    color: "#212121"
  },
  {
    x: "Red",
    y: 567,
    color: "#ff5252"
  },
  {
    x: "Pink",
    y: 123,
    color: "#ff4081"
  },
  {
    x: "Violet",
    y: 19,
    color: "#e040fb"
  },
  {
    x: "Purple",
    y: 128,
    color: "#7c4dff"
  },
  {
    x: "Indigo",
    y: 1234,
    color: "#536dfe"
  },
  {
    x: "Blue",
    y: 567,
    color: "#40c4ff"
  },
  {
    x: "Green",
    y: 135,
    color: "#69f0ae"
  },
  {
    x: "Yellow",
    y: 560,
    color: "#ffff41"
  },
  {
    x: "Amber",
    y: 234,
    color: "#ffd740"
  },
  {
    x: "Orange",
    y: 1546,
    color: "#ffab40"
  }
];

export const MockDataDate: VerticalBarSeriesPoint[] = [
  { x: new Date("01/02/2018").getTime(), y: 6000 },
  { x: new Date("01/03/2018").getTime(), y: 8000 },
  { x: new Date("01/04/2018").getTime(), y: 9000 },
  { x: new Date("01/05/2018").getTime(), y: 7000 },
  { x: new Date("01/06/2018").getTime(), y: 8000 },
  { x: new Date("01/07/2018").getTime(), y: 5000 },
  { x: new Date("01/08/2018").getTime(), y: 9000 }
];

export const MockDataLens: VerticalBarSeriesPoint[] = [
  { x: "Aviator", y: 2323 },
  { x: "Square", y: 2567 },
  { x: "Rectangle", y: 3962 },
  { x: "Butterfly", y: 303 },
  { x: "Round", y: 2045 },
  { x: "Oval", y: 3445 }
];

export const MockDataFrames: Frame[] = [
  {
    frameSKU: "23-00670",
    price: 199,
    brand: "Polaroid",
    color: "Black",
    lensStyle: "Aviator",
    numberOfViews: 1140
  },
  {
    frameSKU: "26-10571",
    price: 240,
    brand: "Ray-Ban",
    color: "Red",
    lensStyle: "Oval",
    numberOfViews: 6382
  },
  {
    frameSKU: "43-55667",
    price: 720,
    brand: "Furla",
    color: "Pink",
    lensStyle: "Round",
    numberOfViews: 1241
  },
  {
    frameSKU: "03-67290",
    price: 430,
    brand: "Lozza",
    color: "Brown",
    lensStyle: "Oval",
    numberOfViews: 5044
  },
  {
    frameSKU: "80-00356",
    price: 130,
    brand: "Polaroid",
    color: "Purple",
    lensStyle: "Butterfly",
    numberOfViews: 5023
  },
  {
    frameSKU: "11-04929",
    price: 400,
    brand: "Marc Jacobs",
    color: "Brown",
    lensStyle: "Square",
    numberOfViews: 3740
  },
  {
    frameSKU: "78-03349",
    price: 399,
    brand: "Calvin Klein",
    color: "Black",
    lensStyle: "Rectangle",
    numberOfViews: 3800
  },
  {
    frameSKU: "13-34785",
    price: 830,
    brand: "Diesel",
    color: "Blue",
    lensStyle: "Rectangle",
    numberOfViews: 2730
  },
  {
    frameSKU: "47-73930",
    price: 199,
    brand: "Michael Kors",
    color: "Orange",
    lensStyle: "Square",
    numberOfViews: 4380
  },
  {
    frameSKU: "29-37930",
    price: 270,
    brand: "Polaroid",
    color: "Orange",
    lensStyle: "Aviator",
    numberOfViews: 2800
  }
];

export const getOptions = (data: VerticalBarSeriesPoint[]): Option[] => {
  let genertatedOptions: Option[] = data.map(el => {
    return {
      name: el.x as string,
      selected: false,
      color: el.color ? el.color : undefined
    };
  });
  return genertatedOptions;
};

export const getSelectedBrands = (
  options: Option[],
  data: VerticalBarSeriesPoint[]
): VerticalBarSeriesPoint[] => {
  const selectedNames: string[] = [];
  options.forEach(el => {
    el.selected ? selectedNames.push(el.name) : "";
  });

  const selectedData = data.reduce(
    (acc, cur) => {
      if (selectedNames.includes(cur.x as string)) acc.push(cur);
      return acc;
    },
    [] as VerticalBarSeriesPoint[]
  );

  /* this way the graph will still appear and will have a height of 10000 */
  if (selectedData.length >= 1) return selectedData;
  else
    return [
      {
        x: "",
        y: 10000
      }
    ];
};
